import React, { useState } from "react";
import { Col, Container, Row, Modal, Button, Form } from "react-bootstrap";
import TitleBlock from "../TitleBlock";
import HotelImage from "../../assets/images/brand/hotelimg.png";
import { Link } from "react-router-dom";
const Packages = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const rot = ["fsda", "sdf", "as"];
  return (
    <div style={{ background: "#F9F6EE" }} className="component_bg">
      {window.location.href.includes("branch") ? (
        ""
      ) : (
        <TitleBlock
          number="05"
          pretitle="Offers"
          title="Packages & Specials"
          desc="Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptate
          aliquid nesciunt pariatur reprehenderit, possimus labore eligendi
          beatae facilis eum maiores. Laudantium repellat veniam obcaecati sed
          dolores laborum unde placeat quod."
        />
      )}
      <Container>
        <Row>
          {rot.map((m) => (
            <Col md={4}>
              <section className="branchCard " style={{ background: "white" }}>
                <figure className="branchCard-image">
                  <img src={HotelImage} alt="" />
                </figure>
                <h2 className="branchCard-title">Seminar Hall</h2>

                <p className="branchCard-paragraph">
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                  Vitae quasi dolore magnam hic esse aperiam obcaecati aliquam
                  distinctio doloremque atque.
                </p>

                <section className="text-center">
                  <Link
                    to=""
                    className="bton bton--md bton--ghost"
                    onClick={handleShow}
                  >
                    Make an Enquiry{" "}
                  </Link>
                </section>
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Make an Inquiry</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col md={6}>
                        <div className="personal-info">
                          <p>personal Information</p>
                          <Form.Label>Name</Form.Label>
                          <Form.Group
                            className="mb-4"
                            controlId="formBasicEmail"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Enter your fullname"
                            />
                          </Form.Group>
                          <Form.Label>Email Address</Form.Label>
                          <Form.Group
                            className="mb-4"
                            controlId="formBasicEmail"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Enter your email address"
                            />
                          </Form.Group>
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Group
                            className="mb-4"
                            controlId="formBasicEmail"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Enter your phone number"
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="personal-info">
                          <p>Event Information</p>
                          <Form.Label>Event Type</Form.Label>
                          <Form.Group
                            className="mb-4"
                            controlId="formBasicEmail"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Eg:meeting & Conference"
                            />
                          </Form.Group>
                          <Form.Label>Number of Persons</Form.Label>
                          <Form.Group
                            className="mb-4"
                            controlId="formBasicEmail"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Total guests"
                            />
                          </Form.Group>
                          <Form.Label>Date and Time</Form.Label>
                          <Form.Group
                            className="mb-4"
                            controlId="formBasicEmail"
                          >
                            <Form.Control
                              type="text"
                              placeholder="Eg:2020/02/02 4:00 PM"
                            />
                          </Form.Group>
                        </div>
                      </Col>
                      <Col md={12}>
                  <Form.Label>Message</Form.Label>
                  <Form.Group className="mb-4" controlId="formBasicEmail">
                    <Form.Control
                      as="textarea"
                      placeholder="Type your message"
                      rows={5}
                    />{" "}
                  </Form.Group>
                </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <button  onClick={handleClose} className="bton bton--md bton--ghost">
                      Save Changes
                    </button>
                  </Modal.Footer>
                </Modal>
              </section>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Packages;
